export const msalConfig = {
    auth: {
        clientId: "e973d10d-a36f-4b66-8e53-31804e652b78 ",
        authority: "https://login.microsoftonline.com/c37fdd0e-f59d-49aa-a549-a5bfed96a57d",
        // redirectUri: "",
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["User.Read"]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};